import { render, staticRenderFns } from "./ProjectFormTab.vue?vue&type=template&id=0c9a5a10&"
import script from "./ProjectFormTab.vue?vue&type=script&lang=js&"
export * from "./ProjectFormTab.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFormTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports